export function getViewportWidth() {
    let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    return viewportWidth;
}

export function getViewportHeight() {
    let viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    return viewportHeight;
}